import React, { useState } from 'react';

import DateFnsUtils from '@date-io/date-fns';

import { makeStyles } from '@material-ui/core/styles';
import Button         from '@material-ui/core/Button';
import Grid           from '@material-ui/core/Grid';
import Paper          from '@material-ui/core/Paper';
import Typography     from '@material-ui/core/Typography';

import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import { KeyboardDatePicker }  from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { date } from '../util';

const style = {
  reports: makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(4),
    },
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: theme.spacing(8),
      // '& > *': {
      //   margin: theme.spacing(1),
      //   width: theme.spacing(16),
      //   height: theme.spacing(16),
      // },
    },
    title: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
  })),
};

export default function Reports(props) {
  const classes = style.reports();

  const [paidFrom, setPaidFrom] = useState(Date.now());
  const [paidTo, setPaidTo] = useState(Date.now());

  const { path, request, ticketer } = props.context.getStates();

  if (path === '/reports') {
    return (
      <div className={classes.root}>
        <Grid container direction="row"
          alignItems="stretch"
          spacing={4}
        >
          <Grid item xs={4}>
            <Paper className={classes.paper}>
              <div className={classes.title}>
                <Typography variant="h6">
                  {'결제 내역'}
                </Typography>
                <Button variant="outlined" size="small"
                  className={classes.button}
                  onClick={() => {
                    request.postSecurely('/report/payment', {
                      paidFrom: paidFrom - paidFrom % 86400000 - 3600000 * 9,
                      paidTo: paidTo - paidTo % 86400000 + 86400000 - 3600000 * 9,
                      ticketer, 
                    }, () => {
                    }, `payments.${date.withoutTime(paidFrom)}-${date.withoutTime(paidTo)}.xlsx`);
                  }}
                  startIcon={<CloudDownloadIcon color="primary" />}
                >{'다운로드'}</Button>
              </div>

              <div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker format="yyyy/MM/dd"
                    // label={'결제일'}
                    onChange={(datetime) => { setPaidFrom(datetime.getTime()); }}
                    value={new Date(paidFrom)}
                  />
                </MuiPickersUtilsProvider>

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker format="yyyy/MM/dd"
                    // label={'결제일'}
                    onChange={(datetime) => { setPaidTo(datetime.getTime()); }}
                    value={new Date(paidTo)}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper className={classes.paper}>
              <div className={classes.title}>
                <Typography variant="h6">
                  {'참가 내역'}
                </Typography>
                <Button variant="outlined" size="small"
                  className={classes.button}
                  startIcon={<CloudDownloadIcon color="primary" />}
                >{'다운로드'}</Button>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  } else {
    return null;
  }
}